import { useState, useEffect } from 'react';
import { Switch } from '@components';

type FilterProps = {
	meta: any;
	header: any;
	filterData: any;
	onChange: (val: any) => void;
}

export const FilterCustomPartialContainsDangerousGoods = (props: FilterProps) => {
	const { meta, header, filterData, onChange } = props;
	const fullName = meta?.columnFullName;
	const [switchChecked, setSwitchChecked] = useState(false);
	const changeSwitchValue = () => {
		setSwitchChecked(!switchChecked);
		const columnField = meta?.databaseLocation ?? header;
		const value = !switchChecked;
		const operatorValue = 'customPartialContainsDangerousGoods';
		if (meta.canReturnFalse) {
			onChange({
				value, columnField, operatorValue
			});
		} else {
			onChange(switchChecked ? null : {
				value, columnField, operatorValue
			});
		}
	}
	useEffect(() => {
		setSwitchChecked(filterData?.value || false);
	}, [filterData]);
	return (
		<div>
			<Switch label='' value={fullName !== undefined ? fullName : header} checked={switchChecked} onChange={() => changeSwitchValue()} name={''}/>
		</div>
	);
}